import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=1143ac64&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=1143ac64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143ac64",
  null
  
)

export default component.exports